import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SharedServiceService {
  private issuedSource = new BehaviorSubject<boolean>(false);
  private yearsSource = new BehaviorSubject<number>(0);

  issued$ = this.issuedSource.asObservable();
  years$ = this.yearsSource.asObservable();

  setIssued(value: boolean) {
    this.issuedSource.next(value);
  }
  setYears(value: number) {
    this.yearsSource.next(value);
  }

  constructor() {}
}
